/** Seeded display names — compare to `status.name` in UI/lifecycle only, not for DB lookups. */
export const salesOrderStatusName = {
    DRAFT: 'Draft',
    AWAITING_APPROVAL: 'Awaiting Approval',
    SUBMITTED: 'Submitted',
    ACCEPTED: 'Accepted',
    DELIVERY_SCHEDULING: 'Delivery Scheduling',
    READY_TO_DELIVER: 'Ready to Deliver',
    SHIPPED: 'Shipped',
    COMPLETE: 'Complete',
    CANCELLED: 'Cancelled',
    REJECTED: 'Rejected',
};
//# sourceMappingURL=sales-order-status-name.js.map